export default "__VITE_ASSET__DHAU7ALL__"